// The h/m/s arithmetic the Marketing elements run on, lifted out of step3's
// `hoursToSeconds` / `changeTimeFormat` pair so the panel, the drawer and the
// list all read a time the same way.
//
// The player stores both halves of a timing: `seconds` (a number, what the
// player compares against) and `time` (an `HH:MM:SS` string, what the old
// tables showed). These three helpers are the only place that conversion runs.

const int = value => {
  const number = Number(value);
  return Number.isFinite(number) ? Math.trunc(number) : 0;
};

const pad = value => String(int(value)).padStart(2, '0');

export const toSeconds = ({ hours, minutes, seconds } = {}) =>
  int(hours) * 3600 + int(minutes) * 60 + int(seconds);

export const fromSeconds = total => {
  const value = Math.max(0, int(total));
  return {
    hours: Math.floor(value / 3600),
    minutes: Math.floor((value % 3600) / 60),
    seconds: value % 60,
  };
};

export const formatTime = total => {
  const { hours, minutes, seconds } = fromSeconds(total);
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

// The stored `HH:MM:SS` string is authoritative for videos saved before this
// screen existed, so reading an element back goes through the string.
export const parseTime = value => {
  const parts = String(value || '').split(':');
  return {
    hours: int(parts[0]),
    minutes: int(parts[1]),
    seconds: int(parts[2]),
  };
};

export default { toSeconds, fromSeconds, formatTime, parseTime };
